// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EscoordV1Api = class EscoordV1Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Search Accounts for match on Program identifier and other criteria.
     * @param enterpriseCoordinatorAccountUpsearchRequestModel Model containing search criteria
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountUpsearchByTenantIdProgramId(enterpriseCoordinatorAccountUpsearchRequestModel, xProgramId) {
        const _url_ = '/escoord/v1/AccountUpsearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enterpriseCoordinatorAccountUpsearchRequestModel' is not null or undefined
        if (enterpriseCoordinatorAccountUpsearchRequestModel === null || enterpriseCoordinatorAccountUpsearchRequestModel === undefined) {
            throw new Error('Required parameter enterpriseCoordinatorAccountUpsearchRequestModel was null or undefined when calling accountUpsearchByTenantIdProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enterpriseCoordinatorAccountUpsearchRequestModel, "EnterpriseCoordinatorAccountUpsearchRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnterpriseCoordinatorAccountUpsearchModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Search Accounts for match on Program identifier and other criteria.
     * @param enterpriseCoordinatorSiteAccountUpsearchRequestModel Model containing search criteria
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountUpsearchByTenantIdProgramId(enterpriseCoordinatorSiteAccountUpsearchRequestModel, xProgramId) {
        const _url_ = '/escoord/v1/SiteAccountUpsearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enterpriseCoordinatorSiteAccountUpsearchRequestModel' is not null or undefined
        if (enterpriseCoordinatorSiteAccountUpsearchRequestModel === null || enterpriseCoordinatorSiteAccountUpsearchRequestModel === undefined) {
            throw new Error('Required parameter enterpriseCoordinatorSiteAccountUpsearchRequestModel was null or undefined when calling siteAccountUpsearchByTenantIdProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enterpriseCoordinatorSiteAccountUpsearchRequestModel, "EnterpriseCoordinatorSiteAccountUpsearchRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnterpriseCoordinatorSiteAccountUpsearchModelResponse");
        }
        return response;
    }
};
EscoordV1Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EscoordV1Api);
export { EscoordV1Api };
//# sourceMappingURL=escoordV1Api.js.map